import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { AbstractComponent } from '../../../commons/abstract.component'

@Component({
    selector: 'confirmation-component',
    // templateUrl: './confirmation.component.html',
    templateUrl: './confirmation.v2.component.html',
    styleUrls: ['./confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationComponent extends AbstractComponent implements OnInit {
  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<ConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {
    super(injector)
  }

  ngOnInit(): void {
    if (!this.data) {
      this.data = this.t('shared.confirmation.defaultMessage')
    }
  }

  onNoClick(): void {
    this.dialogRef.close()
  }
}
